import { RadioGroup, InputWrapper } from 'breeze-intelligence-kit';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FILL_EMPTY_ONLY_OPTION_VAL, OVERWRITE_EXISTING_OPTION_VAL } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FILL_OPTIONS_RADIO_NAME = 'smart-fill-options';
export function FillOption({
  value,
  onChange,
  name = FILL_OPTIONS_RADIO_NAME,
  label = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartFillModal.radioGroup.label"
  })
}) {
  const handleChange = newValue => {
    onChange(newValue);
  };
  return /*#__PURE__*/_jsx(InputWrapper, {
    label: label,
    children: /*#__PURE__*/_jsxs(RadioGroup, {
      name: name,
      onChange: handleChange,
      value: value,
      children: [/*#__PURE__*/_jsx(RadioGroup.Radio, {
        value: FILL_EMPTY_ONLY_OPTION_VAL,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartFillModal.radioGroup.fillEmptyOnly"
        })
      }), /*#__PURE__*/_jsx(RadioGroup.Radio, {
        value: OVERWRITE_EXISTING_OPTION_VAL,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartFillModal.radioGroup.overwriteExisting"
        })
      })]
    })
  });
}